// extracted by mini-css-extract-plugin
export default {"container":"RouteContainer_container__UJn2P"};